import PropTypes from "prop-types"
import React, { useEffect } from "react"

import Divider from "src/components/Divider"

import { useConfettiOnce } from "src/hooks/use_confetti_once"
import { useTracker } from "src/hooks/use_tracker"

import AccountSubmitted from "./Submitted/AccountSubmitted"
import CreateAccountCard from "./Submitted/CreateAccountCard"
import SignInCard from "./Submitted/SignInCard"

const ContractSubmitted = ({
  account,
  copy,
  createAccountUrl,
  marina,
  quoteId,
  signInUrl,
  slot,
  subtitle,
  title,
}) => {
  const tracker = useTracker()
  useConfettiOnce(quoteId, Boolean(slot))

  useEffect(() => {
    if (!marina || !quoteId) return

    tracker.trackEvent("contracts_v2:confirmation_viewed", {
      slot: slot || "none",
      contract_quote_id: quoteId,
      marina_id: marina.id,
      marina_name: marina.name,
    })
  }, [tracker, slot, quoteId, marina])

  const renderSlot = () => {
    switch (slot) {
      case "createAccount":
        return (
          <>
            <p className="mb-4 text-sm font-semibold text-gray-700">
              {copy.whatsNext}
            </p>
            <CreateAccountCard
              copy={copy}
              createAccountUrl={createAccountUrl}
              marina={marina}
              quoteId={quoteId}
            />
          </>
        )
      case "signIn":
        return (
          <SignInCard
            copy={copy}
            marina={marina}
            quoteId={quoteId}
            signInUrl={signInUrl}
          />
        )
      case "account":
        return (
          <AccountSubmitted
            boat={account.boat}
            contractChatUrl={account.contractChatUrl}
            copy={copy}
            downloadPdfUrl={account.downloadPdfUrl}
            homeport={account.homeport}
            homeportIsMarina={account.homeportIsMarina}
            marina={marina}
            mobileWebview={account.mobileWebview}
            quoteCompleted={account.quoteCompleted}
            quoteId={quoteId}
            reservationUrl={account.reservationUrl}
            savedPdfUrl={account.savedPdfUrl}
          />
        )
      case "signedInOther":
        return <p className="text-gray-700">{copy.body}</p>
      default:
        return null
    }
  }

  return (
    <div className="w-full">
      <div className="flex flex-col items-start gap-2 lg:flex-row-reverse lg:items-center lg:justify-end lg:gap-3">
        <i className="fa-solid fa-circle-check text-7xl text-teal-400" />
        <h1 className="m-0 text-[42px] font-bold leading-tight text-gray-900">
          {title}
        </h1>
      </div>
      <p className="mb-6 mt-2 text-base font-semibold text-gray-900">
        {subtitle}
      </p>
      <Divider />
      {slot && <div className="mt-6">{renderSlot()}</div>}
    </div>
  )
}

ContractSubmitted.propTypes = {
  account: PropTypes.object,
  copy: PropTypes.object,
  createAccountUrl: PropTypes.string,
  marina: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    image: PropTypes.string,
  }),
  quoteId: PropTypes.string,
  signInUrl: PropTypes.string,
  slot: PropTypes.oneOf([
    "createAccount",
    "signIn",
    "signedInOther",
    "account",
  ]),
  subtitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default ContractSubmitted
